export const MARKINGS = ['Partially Met', 'Achieving', 'High Performing', 'Exceeding'];
export const POSITIONS = [
  '9 Inconsistent',
  '8 Effective',
  '7 Early Promise',
  '6 Expert',
  '5 Good',
  '4 Strong',
  '3 High Potential',
  '2 Excellent',
  '1 Star',
];

const DARK_GREEN = 'hsl(140 60% 28%)';
const MARKING_COLOURS = ['#f4cccc', '#fce5cd', '#d9ead3', DARK_GREEN];
const POSITION_COLOURS = [
  '#f4cccc',
  '#f6d4cc',
  '#f8dccd',
  '#fce5cd',
  '#f6e8cf',
  '#e8ead1',
  '#d9ead3',
  '#bddcba',
  DARK_GREEN,
];

export default function ModerationDistribution({
  title,
  values,
  outcomes,
}: {
  title: string;
  values: string[];
  outcomes: string[];
}) {
  const rated = values.map((value) => (outcomes.includes(value) ? value : 'Not provided'));
  const segments = [...outcomes, 'Not provided']
    .map((label, index) => ({
      label,
      count: rated.filter((value) => value === label).length,
      colour:
        label === 'Not provided'
          ? '#b1b4b6'
          : (outcomes.length === MARKINGS.length ? MARKING_COLOURS : POSITION_COLOURS)[index],
    }))
    .filter(({ count }) => count > 0);
  return (
    <section className="scs-moderation-distribution" aria-label={title}>
      <h2 className="govuk-heading-s">{title}</h2>
      {rated.length ? (
        <>
          <div className="scs-moderation-distribution__bar">
            {segments.map(({ label, count, colour }) => {
              const percentage = (count * 100) / rated.length;
              const text = `${Number(percentage.toFixed(1))}%`;
              return (
                <div
                  key={label}
                  className="scs-moderation-distribution__segment"
                  style={{
                    flexBasis: `${percentage}%`,
                    backgroundColor: colour,
                    color: colour === DARK_GREEN ? '#ffffff' : '#0b0c0c',
                  }}
                  title={`${label}: ${text} (${count})`}
                  aria-label={`${label}: ${text} (${count})`}
                >
                  <span
                    aria-hidden="true"
                    style={percentage < 6 ? { writingMode: 'vertical-rl' } : undefined}
                  >
                    {text}
                  </span>
                </div>
              );
            })}
          </div>
          <ul className="scs-moderation-distribution__legend govuk-list">
            {segments.map(({ label, count, colour }) => (
              <li key={label}>
                <span style={{ backgroundColor: colour }} aria-hidden="true" />
                {label} ({count})
              </li>
            ))}
          </ul>
        </>
      ) : (
        <p className="govuk-body">No ratings set yet.</p>
      )}
    </section>
  );
}
